{
  "links" : {
    "triggerLinksDescription" : "Utlösarlänkar Aktivera Du för att lägga länkar Inre SMS och Gmail, som Aktivera Du för att spåra specifika kundaktiviteter och utlösare instanser baserade På När klickas på länken.",
    "enterName" : "Ange namn",
    "enterLinkURL" : "Ange Länkens URL",
    "save" : "Arkivera",
    "cancel" : "Avbryt",
    "delete" : "Radera",
    "aboutToDeleteLink" : "`Du're Om för att ta bort ${deleteRowName} utlösare Länk. Raderad länk kan inte återställas, är du säker på att du vill Fortsätt?`",
    "noTriggerLinksFound" : "Inga Utlösarlänkar hittades",
    "getStartedByAddingNewTriggerLinks" : "Kom igång Via att lägga till Ny Utlösarlänkar",
    "newTriggerLink" : "Ny utlösare Länk",
    "searchNoMatch" : "Din Sök matchade inte någon utlösare länk.",
    "link" : "Länk",
    "addLink" : "Lägg till Länk",
    "linkURL" : "Länkens URL",
    "name" : "Namn",
    "pleaseEnterNonEmptyLinkName" : "Vänligen ange ett ej tomt länknamn",
    "pleaseEnterURL" : "Vänligen ange URL",
    "actions" : "aktiviteter",
    "linkKey" : "Länk Nyckel",
    "keyCopied" : "Nyckel Kopierad"
  }
}
